import { SensorConfigurationAnalyticsSummary } from 'src/api'

export interface ConfigurationAnalyticsGridRow {
  key: string
  metric: string
  value?: number
  indent?: boolean
}

export const buildConfigurationAnalyticsRows = (summary?: SensorConfigurationAnalyticsSummary): ConfigurationAnalyticsGridRow[] => [
  { key: 'total', metric: 'Total sensors', value: summary?.total },
  { key: 'default', metric: 'Default configuration', value: summary?.default?.total },
  { key: 'default-matches', metric: 'Matches the current default', value: summary?.default?.matches, indent: true },
  { key: 'default-not-matches', metric: "Doesn't match the current default", value: summary?.default?.notMatches, indent: true },
  { key: 'custom', metric: 'Custom configuration', value: summary?.custom },
  { key: 'unknown', metric: 'Unknown', value: summary?.unknown }
]
